import { useValidatePasswordResetToken } from "@tandemdiabetes/sugarmate-api-react-client"
import { useParams } from "@tanstack/react-router"
import { useMemo } from "react"

export function useValidateToken(baseURL?: string) {
  const validateToken = useValidatePasswordResetToken(baseURL)

  const userId = useParams({
    from: "/public/users/$userId/password/edit",
    select: (s) => s.userId,
  })

  return useMemo(
    () => !validateToken
      ? undefined
      : () => {
        const urlParams = new URLSearchParams(window.location.search)
        const token = urlParams.get("token") ?? ""

        return validateToken(
          userId,
          token,
        )
      },
    [
      userId,
      validateToken,
    ],
  )
}
